const animOnScroll = (items, options = { threshold: 0.3 }, once = true) => {
  if (items.length === 0) return;

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
      } else if (once === false) {
        entry.target.classList.remove('show');
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  items.forEach((item) => {
    observer.observe(item);
  });
};
